export const shippingFields = /* GraphQL */ `
  fragment shippingFields on Shipping {
    free
    type
  }
`
